import React, { useEffect, useState } from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { getEvents } from '../Service/Api';
const Events = () => {
    var settings = {
        loop: true,
        margin: 10,
        responsiveClass: true,
        autoplay: true,
        dots: true,
        items: 3,
        responsive: {
            0: {
                items: 1,
            },
            567: {
                items: 2,
            },
            768: {
                items: 2,
            },
            992: {
                items: 3,
            },
            1200: {
                items: 2,
            }, 
            1350: {
                items: 3,
            },
            1600: {
                items: 3,
            }
        }
    };
    const [data, setData] = useState([]);
    useEffect(() => {
      const getData = async () => {
        const datas = await getEvents();
        setData(datas);
      };
      getData();
    }, []);


    return (
        <OwlCarousel className='owl-theme' loop margin={10} {...settings}>
             {data?.length > 0 &&
        data?.map((item, index) => (
            <div className="item"  key={index}>
                <div className='evt-blk'>
                    <div className="evt-img">
                        <img src={`https://webapi.entab.info/api/image?url=${item?.images[0]}`} />
                        <div className="date">{item.date} <span>25</span></div>
                        {/* <div className="date">Mar <span>25</span></div> */}
                        
                        <div className="evt-title"><h3>{item.title}</h3></div>
                    </div>
                    <div className='evt-content'>
                        <p>{item.description}</p>
                        <p><img src="/Images/location.png" />{item.location} <span><img src="/Images/clock.png"></img>{item.time}</span></p>
                    </div>
                </div>
            </div>
        
              ))}
        </OwlCarousel>
    );
};

export default Events;
